import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectMill, isPdf } from "../actions/millActions";
import { toggleTour, setCarousel } from "../actions/settingActions";

import { Link, withRouter } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";
import DocumentTitle from "react-document-title";

// import ScrollTop from "./ScrollTop";
import Info from "./InfoPopup.js";
import ImageCarousel from "./ImageCarousel";
import HtmlText from "./HtmlText";

import { ReactComponent as DownloadCloud } from "../icons/cloud_download.svg";
import { ReactComponent as ArrowBack } from "../icons/arrow_circle_down.svg";

import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import { Typography } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  appBar: {
    height: "66px",
    position: "relative",
    backgroundColor: "white",
    color: theme.palette.primary.main,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    padding: "0px 15px",
    width: "100%",
  },
  tooltip: {
    backgroundColor: "white",
    color: "#00568E",
    fontSize: "9pt",
    border: "1px solid #00568E",
  },
});

const municipality = {
  buende: "Bue",
  enger: "En",
  herford: "Hf",
  hiddenhausen: "Hi",
  kirchlengern: "Ki",
  loehne: "Loe",
  roedinghausen: "Roe",
  spenge: "Sp",
  vlotho: "Vl",
};

class FurtherInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: props.progress,
      gemeinde: "",
      nr: "",
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.setCarousel("images");
    this.props.isPdf(true);
    if (this.props.tourOpen) {
      this.props.toggleTour();
    }
    if (this.props.selected.Objektnr) {
      this.setState({ progress: false });
    } else if (!this.props.progress) {
      this.setObjectNr();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.progress !== this.props.progress && !this.props.progress) {
      this.setObjectNr();
    }
  }

  setObjectNr = () => {
    var gemeinde = this.props.match.params.gemeinde.toLowerCase();
    gemeinde = gemeinde
      .replace("ö", "oe")
      .replace("ä", "ae")
      .replace("ü", "ue");
    gemeinde = municipality[gemeinde];
    var nr = parseInt(this.props.match.params.objektnr).toString();
    this.setState({ gemeinde, nr }, () => {
      try {
        nr = nr.padStart(2, "0");
        var objectnr = gemeinde + "_" + nr;
        var millObject = this.props.mills.features.filter(
          (mill) => mill.properties.Objektnr === objectnr
        )[0].properties;
        this.props.selectMill(millObject, "map");
        this.setState({ progress: false });
      } catch (error) {
        this.setState({ progress: false });
      }
    });
  };

  getRealMunicipalityName = () => {
    var gemeinde =
      Object.keys(municipality)[
        Object.values(municipality).indexOf(this.state.gemeinde)
      ];
    gemeinde = gemeinde.charAt(0).toUpperCase() + gemeinde.slice(1);
    gemeinde = gemeinde.replace("oe", "ö").replace("ue", "ü");
    return gemeinde;
  };

  getPictures = (path) => {
    var pictures = [];
    var bilder = this.props.selected.Bilder.split(",");
    bilder = bilder
      .filter((b) => b.length > 0)
      .map((bil) => {
        return `${path}/bilder/${bil.trim()}`;
      });
    if (this.props.selected.Thumb) {
      pictures.push(`${path}/thumb/${this.props.selected.Thumb}`);
    }
    pictures = pictures.concat(bilder);
    return pictures;
  };

  render() {
    const path = `${process.env.REACT_APP_DOCUMENT_URL}/${this.props.selected.Gemeinde}/${this.props.selected.Objektnr}`;
    return (
      <Dialog
        fullScreen
        open={true}
        style={{ zIndex: 1302 }}
        onClose={() => {
          this.props.setCarousel("mills");
          this.props.history.push("/muehlenkataster");
        }}
      >
        <AppBar
          position="static"
          className={this.props.classes.appBar}
          id="topanchor"
        >
          <Toolbar style={{ padding: 0, height: "inherit" }} id="topAnchor">
            <Tooltip
              title="zurück"
              classes={{
                tooltip: this.props.classes.tooltip,
              }}
            >
              <Link
                to="/muehlenkataster"
                style={{
                  textDecoration: "none",
                  color: "#00568E",
                  padding: 0,
                }}
                onClick={() => {
                  this.props.setCarousel("mills");
                  this.props.isPdf(false);
                }}
              >
                <ArrowBack style={{ transform: "rotate(90deg)" }} />
              </Link>
            </Tooltip>

            <div
              style={{
                fontWeight: "bold",
                flexGrow: 1,
                marginLeft: "calc(10px - 40px + 37.3667px)",
                color: "#00568E",
              }}
            >
              Mühlen im Kreis Herford
            </div>
            {this.props.selected.PDF ? (
              <Tooltip
                title="PDF herunterladen"
                classes={{
                  tooltip: this.props.classes.tooltip,
                }}
              >
                <IconButton style={{ padding: 0, marginRight: "15px" }}>
                  <a
                    download
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${path}/pdf/${this.props.selected.PDF}`}
                  >
                    <DownloadCloud />
                  </a>
                </IconButton>
              </Tooltip>
            ) : null}

            <Info color={"#00568E"} information={true} />
          </Toolbar>
        </AppBar>

        {this.state.progress ? (
          <div className="spinner" style={{ height: "calc(50vh - 66px)" }}>
            <div style={{ justifyContent: "center", display: "flex" }}>
              <PulseLoader
                color={"#00568E"}
                loading={this.state.progress}
                size={35}
                margin={5}
              />
            </div>
            <p style={{ marginTop: "20px", textAlign: "center" }}>
              Daten werden vom Server geladen.
            </p>
          </div>
        ) : (
          <DocumentTitle
            title={this.props.selected.Name || "Mühle nicht gefunden"}
          >
            {this.props.selected && this.props.selected.Name ? (
              <div ref={this.ref}>
                {/* <ScrollTop anchor="topanchor" target={this.ref} /> */}
                {this.props.selected.Bilder || this.props.selected.Thumb ? (
                  <ImageCarousel pictures={this.getPictures(path)} />
                ) : (
                  <div>
                    <div
                      style={{
                        padding: "1.25rem",
                      }}
                    >
                      Es sind keine Fotos für die Mühle vorhanden.
                    </div>
                    <div
                      style={{
                        width: "calc(100% - 1.25rem - 1.25rem)",
                        borderTop: "1px solid #00568E",
                        padding: "20px 0",
                        margin: "0 1.25rem",
                      }}
                    ></div>
                  </div>
                )}

                {this.props.selected.HTML ? (
                  <div>
                    <HtmlText
                      path={`${path}/html`}
                      file={this.props.selected.HTML}
                      objectnr={this.props.selected.Objektnr}
                    />
                  </div>
                ) : (
                  <div style={{ marginTop: "1.25rem", padding: "0 1rem" }}>
                    Es gibt keine weiteren Informationen zu der Mühle mit der Nr
                    "{this.state.nr}"".
                  </div>
                )}
              </div>
            ) : (
              <div
                style={{
                  padding: "1.25rem",
                }}
              >
                <Typography style={{ fontSize: "1rem", fontWeight: "600" }}>
                  Es konnte keine Mühle gefunden werden.
                </Typography>
                {!this.state.gemeinde
                  ? `Die gesuchte Gemeinde bzw. Stadt "${this.props.match.params.gemeinde}" existiert nicht im Kreis Herford.`
                  : this.state.nr === "NaN"
                  ? `Die Mühlen-Nr. muss eine Zahl sein. ("${this.props.match.params.objektnr}" erfüllt dieses Kriterium nicht.)`
                  : this.state.nr < 1
                  ? `Die Mühlen-Nr. muss eine positive Zahl sein. ("${this.state.nr}" erfüllt dieses Kriterium nicht.)`
                  : `In ${this.getRealMunicipalityName()} gibt es keine Mühle mit der Nr. "${
                      this.state.nr
                    }".`}
                <Typography
                  style={{
                    marginTop: "30px",
                    fontSize: "1rem",
                    color: "#00568E",
                  }}
                >
                  {this.state.gemeinde &&
                  this.state.nr !== "NaN" &&
                  this.state.nr >= 1
                    ? "Wählen Sie eine niedrigere Mühlen-Nr. oder entdecken "
                    : "Entdecken "}
                  Sie alle Mühlen im Kreis Herford in der{" "}
                  <Link to="/muehlenkataster" className={"appLink"}>
                    Übersicht
                  </Link>
                  .
                </Typography>
              </div>
            )}
          </DocumentTitle>
        )}
      </Dialog>
    );
  }
}

FurtherInformation.propTypes = {
  selected: PropTypes.object.isRequired,
  progress: PropTypes.bool.isRequired,
  toggleTour: PropTypes.func.isRequired,
  tourOpen: PropTypes.bool.isRequired,
  selectMill: PropTypes.func.isRequired,
  mills: PropTypes.object.isRequired,
  setCarousel: PropTypes.func.isRequired,
  isPdf: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  progress: state.mill.progress,
  selected: state.mill.selected,
  tourOpen: state.settings.tour,
  mills: state.mill.mills,
});

export default connect(mapStateToProps, {
  toggleTour,
  selectMill,
  setCarousel,
  isPdf,
})(withStyles(styles, { withTheme: true })(withRouter(FurtherInformation)));
